import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getUserListRequest } from '../../store/modules/users/actions';
import { selectUserList } from '../../store/modules/users/selectors';
import { ListTable, ViewFrame } from '../../components';
import { useActionDispatcher, useTitle } from '../../hooks';

const title = 'Users';

const UserList = () => {
  useTitle(title);

  const { loading, data } = useSelector(selectUserList);
  const getUserList = useActionDispatcher(getUserListRequest);

  const [dirty, setDirty] = useState(true);

  useEffect(() => {
    if (loading) {
      setDirty(false);
    }
  }, [loading]);

  return (
    <ViewFrame title={title}>
      <ListTable
        columns={[
          {
            id: 'ref.full_name_first_last',
            Header: 'Full Name',
          },
          {
            id: 'ref.organization.common_name',
            Header: 'Organization',
          },
          {
            id: 'city',
            Header: 'City',
          },
        ]}
        loading={loading}
        data={data}
        fetch={getUserList}
        dirty={dirty}
        setDirty={setDirty}
        disabledCreate={!data?.permissions.can_add}
      />
    </ViewFrame>
  );
};
export default UserList;
